import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import { toastError, toastSuccess } from "../../../../../utils/constants";
import Modal from "react-modal";
import AdminDrawer from "../../../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../../../common_components/header_with_logo";
import {
    getAgencyRentalAvEquipmentList_action,
    deleteAgencyRentalAvEquipment_action,
    getMstRentalAvEquipmentList_action,
    insertUpdateMstRentalAvEquipment_action,
    deleteMstRentalAvEquipment_action,
} from "../../../../../actions/admin_module_action/master_action/manual_form_master_action/rental_audio_video_master_action";
import Footer from "../../../../../common_components/Footer";


class RentalAudioVideoMaster extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            // Agency contact/bank
            agencyContactBankList: [],
            deleteContactBankID: '',
            isOpenContactBank: false,
            // Equipment items (inline draft list)
            equipmentDraftList: [],
        }

        this.getAgencyContactBankList = this.getAgencyContactBankList.bind(this)
        this.deleteAgencyContactBank = this.deleteAgencyContactBank.bind(this)
        this.onDeleteContactBank = this.onDeleteContactBank.bind(this)
        this.getEquipmentList = this.getEquipmentList.bind(this)
        this.addEquipmentRow = this.addEquipmentRow.bind(this)
        this.deleteEquipmentRow = this.deleteEquipmentRow.bind(this)
        this.handleEquipmentChange = this.handleEquipmentChange.bind(this)
        this.saveEquipments = this.saveEquipments.bind(this)
    }

    componentDidMount() {
        this.getAgencyContactBankList()
        this.getEquipmentList()
    }

    getAgencyContactBankList() {
        this.setState({ isLoading: true })
        this.props.getAgencyRentalAvEquipmentList_action()
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ agencyContactBankList: data.data || [], isLoading: false })
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => { console.log(err); this.setState({ isLoading: false }) })
    }

    onDeleteContactBank(id) {
        this.setState({ deleteContactBankID: id, isOpenContactBank: true })
    }

    deleteAgencyContactBank(id) {
        this.setState({ isLoading: true })
        this.props.deleteAgencyRentalAvEquipment_action(id)
            .then((data) => {
                if (data.error != 1) {
                    toastSuccess("Deleted successfully")
                    this.setState({ isLoading: false, isOpenContactBank: false })
                    setTimeout(() => { this.getAgencyContactBankList() }, 200)
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => { console.log(err); this.setState({ isLoading: false }) })
    }

    getEquipmentList() {
        this.setState({ isLoading: true })
        this.props.getMstRentalAvEquipmentList_action()
            .then((data) => {
                if (data.error != 1) {
                    const rawList = data.data || []
                    const equipmentDraftList = rawList.map(item => ({
                        RentalAvEquipmentID: item.RentalAvEquipmentID,
                        EquipmentDescription: item.EquipmentDescription || '',
                        RateINR: item.RateINR != null ? String(item.RateINR) : '',
                        RateUSD: item.RateUSD != null ? String(item.RateUSD) : '',
                        isNew: false,
                    }))
                    this.setState({ equipmentDraftList, isLoading: false })
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => { console.log(err); this.setState({ isLoading: false }) })
    }

    addEquipmentRow() {
        const { equipmentDraftList } = this.state
        this.setState({
            equipmentDraftList: [...equipmentDraftList, {
                RentalAvEquipmentID: null,
                EquipmentDescription: '',
                RateINR: '',
                RateUSD: '',
                isNew: true,
            }]
        })
    }

    deleteEquipmentRow(index) {
        const { equipmentDraftList } = this.state
        const row = equipmentDraftList[index]
        if (row.isNew) {
            this.setState({ equipmentDraftList: equipmentDraftList.filter((_, i) => i !== index) })
        } else {
            this.setState({ isLoading: true })
            this.props.deleteMstRentalAvEquipment_action(row.RentalAvEquipmentID)
                .then((data) => {
                    if (data.error != 1) {
                        toastSuccess("Deleted successfully")
                        this.getEquipmentList()
                    } else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                })
                .catch((err) => { console.log(err); this.setState({ isLoading: false }) })
        }
    }

    handleEquipmentChange(index, field, value) {
        const { equipmentDraftList } = this.state
        const updated = equipmentDraftList.map((row, i) =>
            i === index ? { ...row, [field]: value } : row
        )
        this.setState({ equipmentDraftList: updated })
    }

    saveEquipments() {
        const { equipmentDraftList } = this.state
        if (equipmentDraftList.length === 0) {
            toastError("Please add at least one row")
            return
        }
        for (let i = 0; i < equipmentDraftList.length; i++) {
            const row = equipmentDraftList[i]
            if (!row.EquipmentDescription.trim()) { toastError(`Row ${i + 1}: Please enter Equipment Description`); return }
            if (row.RateINR === '' || row.RateINR === null) { toastError(`Row ${i + 1}: Please enter Rate (INR)`); return }
            if (row.RateUSD === '' || row.RateUSD === null) { toastError(`Row ${i + 1}: Please enter Rate (USD)`); return }
        }
        const payload = equipmentDraftList.map(row => ({
            RentalAvEquipmentID: row.RentalAvEquipmentID || null,
            EquipmentDescription: row.EquipmentDescription,
            RateINR: parseFloat(row.RateINR) || 0,
            RateUSD: parseFloat(row.RateUSD) || 0,
            ActionID: row.isNew ? 1 : 2,
        }))
        this.setState({ isLoading: true })
        this.props.insertUpdateMstRentalAvEquipment_action(payload)
            .then((data) => {
                if (data.error != 1) {
                    toastSuccess("Equipment saved successfully")
                    this.getEquipmentList()
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => { console.log(err); this.setState({ isLoading: false }) })
    }

    render() {
        const {
            isLoading, agencyContactBankList, isOpenContactBank,
            equipmentDraftList,
        } = this.state

        return (
            <>
                {isLoading ? <Loader></Loader> : null}
                <ToastContainer />
                <HeaderWithLogo />
                <div className="app-content with-dr-container com-height">
                    <AdminDrawer />
                    <div className="main-container">
                        <div className="row m-0">
                            <div className="breadcrumb-scroll-fixed">
                                <h6 className="mb-0 p-2 text-white">Rental Audio Video Master</h6>
                            </div>
                        </div>
                        <div className="admin-top-space p-2 px-0">

                            {/* ── Equipment Items Section ── */}
                            <div className="row m-0 mb-4">
                                <div className="col-12">
                                    <div className="card-header p-2" style={{ paddingLeft: "7px !important" }}>
                                        <h3 className="card-title" style={{ fontSize: 15 }}>Equipment Items</h3>
                                    </div>

                                    {/* Inline editable table */}
                                    <div className="table-responsive">
                                        <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-1">
                                            <thead>
                                                <tr>
                                                    <th className="text-center" style={{ width: 50 }}>S. No.</th>
                                                    <th className="text-center">Equipment Description</th>
                                                    <th className="text-center">Rate (INR)</th>
                                                    <th className="text-center">Rate (USD)</th>
                                                    <th className="text-center" style={{ width: 60 }}>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {equipmentDraftList.length > 0 ? equipmentDraftList.map((row, index) => (
                                                    <tr key={index}>
                                                        <td className="text-center">{index + 1}</td>
                                                        <td className="text-center">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={row.EquipmentDescription}
                                                                onChange={(e) => this.handleEquipmentChange(index, 'EquipmentDescription', e.target.value)}
                                                            />
                                                        </td>
                                                        <td className="text-center">
                                                            <input
                                                                type="number"
                                                                className="form-control text-center"
                                                                value={row.RateINR}
                                                                min={0}
                                                                onKeyDown={(e) => ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault()}
                                                                onChange={(e) => this.handleEquipmentChange(index, 'RateINR', e.target.value)}
                                                            />
                                                        </td>
                                                        <td className="text-center">
                                                            <input
                                                                type="number"
                                                                className="form-control text-center"
                                                                value={row.RateUSD}
                                                                min={0}
                                                                onKeyDown={(e) => ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault()}
                                                                onChange={(e) => this.handleEquipmentChange(index, 'RateUSD', e.target.value)}
                                                            />
                                                        </td>
                                                        <td className="text-center">
                                                            <i
                                                                className="fa fa-trash text-danger"
                                                                style={{ cursor: 'pointer', fontSize: '16px' }}
                                                                onClick={() => this.deleteEquipmentRow(index)}
                                                            />
                                                        </td>
                                                    </tr>
                                                )) : (
                                                    <tr><td className="text-center" colSpan={5}>No record found</td></tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="d-flex justify-content-between mt-2 mb-3">
                                        <button
                                            type="button"
                                            className="btn btn-outline-primary btn-sm"
                                            onClick={this.addEquipmentRow}
                                        >
                                            + Add Row
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-aqua btn-sm"
                                            onClick={this.saveEquipments}
                                        >
                                            Save Equipment
                                        </button>
                                    </div>
                                </div>
                            </div>

                            {/* ── Agency Contact & Bank Section ── */}
                            <div className="row m-0">
                                <div className="table-responsive">
                                    <div className="card-header p-2" style={{ paddingLeft: "7px !important" }}>
                                        <h3 className="card-title" style={{ fontSize: 15 }}>
                                            Agency contact and bank details
                                        </h3>
                                    </div>
                                    <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-1">
                                        <thead>
                                            <tr>
                                                <th className="text-center">Name</th>
                                                <th className="text-center">Address</th>
                                                <th className="text-center">Telephone</th>
                                                <th className="text-center">Mobile</th>
                                                <th className="text-center">Fax</th>
                                                <th className="text-center">Primary Email</th>
                                                <th className="text-center">Secondary Email</th>
                                                <th className="text-center">Bank Name</th>
                                                <th className="text-center">Beneficiary Name</th>
                                                <th className="text-center">Beneficiary Address</th>
                                                <th className="text-center">Account No</th>
                                                <th className="text-center">Swift Code</th>
                                                <th className="text-center">IFSC</th>
                                                <th className="text-center">PAN No</th>
                                                <th className="text-center">GST</th>
                                                <th className="text-center" style={{ width: '80px' }}>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {agencyContactBankList.length > 0 ? agencyContactBankList.map((data, i) => (
                                                <tr key={data.AgencyRentalAvEquipmentID}>
                                                    <td className="text-center">{data.AgencyName}</td>
                                                    <td className="text-center">{data.AgencyAddress}</td>
                                                    <td className="text-center">{data.Telephone}</td>
                                                    <td className="text-center">{data.MobileNo}</td>
                                                    <td className="text-center">{data.Fax}</td>
                                                    <td className="text-center">{data.AgencyEmailPrimary}</td>
                                                    <td className="text-center">{data.AgencyEmailSecondary}</td>
                                                    <td className="text-center">{data.BankName}</td>
                                                    <td className="text-center">{data.BeneficiaryName}</td>
                                                    <td className="text-center">{data.BeneficiaryAddress}</td>
                                                    <td className="text-center">{data.AccountNo}</td>
                                                    <td className="text-center">{data.SwiftCode}</td>
                                                    <td className="text-center">{data.IFSC}</td>
                                                    <td className="text-center">{data.PanNo}</td>
                                                    <td className="text-center">{data.GST}</td>
                                                    <td className="text-center">
                                                        <button
                                                            type="button"
                                                            className="btn btn-outline-primary btn-sm border-0"
                                                            onClick={() => this.props.navigate('/rentalAudioVideoMasterAU', { state: { editData: data } })}
                                                        >
                                                            <i className="fa fa-pencil action_btn_table" />
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="btn btn-outline-danger btn-sm border-0"
                                                            onClick={() => this.onDeleteContactBank(data.AgencyRentalAvEquipmentID)}
                                                        >
                                                            <i className="fa fa-trash action_btn_table" />
                                                        </button>
                                                    </td>
                                                </tr>
                                            )) : (
                                                <tr><td className="text-center" colSpan={16}>No record found</td></tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="text-end px-2 mt-2">
                                <button
                                    type="button"
                                    className="btn btn-aqua"
                                    onClick={() => this.props.navigate('/rentalAudioVideoMasterAU', { state: { editData: null } })}
                                >
                                    Add
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Delete modal - agency contact bank */}
                <Modal isOpen={isOpenContactBank} onRequestClose={() => this.setState({ isOpenContactBank: false })}>
                    <div className="modal-dialog" style={{ marginTop: '20%' }}>
                        <div className="modal-content confirm-logout">
                            <div class="modal-header text-right p-2">
                                <h5 class="modal-title">Do you really want to delete this record?</h5>
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" class="btn btn-aqua"
                                        onClick={() => this.deleteAgencyContactBank(this.state.deleteContactBankID)}
                                    >Yes</button>
                                    <button type="button" class="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }}
                                        onClick={() => this.setState({ isOpenContactBank: false })}
                                    >No</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
                <Footer />
            </>)
    }

}
export default withRouter(connect(null, {
    getAgencyRentalAvEquipmentList_action,
    deleteAgencyRentalAvEquipment_action,
    getMstRentalAvEquipmentList_action,
    insertUpdateMstRentalAvEquipment_action,
    deleteMstRentalAvEquipment_action,
})(RentalAudioVideoMaster));
